import { createContext } from "react";

interface IGlobalContext {
  isAlertOpened: boolean;
  alertText: string;
  alertTitle: string;
  setIsAlertOpened: (opened: boolean) => void;
  setAlertText: (text: string) => void;
  setAlertTitle: (text: string) => void;

  key: number;
  setKey: (number: number) => void;
}

const defaultState = {
  isAlertOpened: false,
  alertText: "",
  alertTitle:"",
  setIsAlertOpened: (opened: boolean) => {},
  setAlertText: (text: string) => {},
  setAlertTitle: (alertTitle: string) => {},
  key: 0,
  setKey: (number: number) => {},
};

const GlobalContext = createContext<IGlobalContext>(defaultState);
export default GlobalContext;
